/* Dropcampagne: de klok, de omslag naar NU LIVE, en de aanmelding bij Klaviyo.

   WAAROM DIT IN DE BROWSER GEBEURT EN NIET IN LIQUID
   Shopify cachet pagina's. Zou de "is het al zover?"-vraag in Liquid staan, dan
   kan een bezoeker een pagina uit de cache krijgen waarop het nog niet zover is
   terwijl het dat allang is. De browser weet altijd hoe laat het werkelijk is,
   dus de omslag gebeurt hier.

   TIJDZONES
   Het moment komt binnen als UTC (2026-08-11T17:00:00Z = dinsdag 19:00
   Amsterdam = woensdag 01:00 Bali). Date.parse leest dat als een absoluut
   tijdstip, dus de teller klopt voor elke bezoeker ongeacht waar die zit en
   ongeacht waar de eigenaar zit. Er wordt nergens met lokale tijd gerekend. */
(function () {
  'use strict';

  /* Dit bestand wordt door elke plek die het dropblok rendert opnieuw
     ingeladen; op de homepage staan de balk en de banner samen, dus twee
     scripttags. Zonder deze wachter draait alles dubbel: twee klok-timers en
     een aanmeldformulier dat elke aanmelding twee keer verstuurt. */
  if (window.__lfDropGestart) return;
  window.__lfDropGestart = true;

  var blokken = document.querySelectorAll('[data-lf-drop]');
  if (!blokken.length) return;

  function tweeCijfers(n) { return n < 10 ? '0' + n : '' + n; }

  function tekenBlok(blok, nu) {
    var moment = Date.parse(blok.dataset.moment);
    if (isNaN(moment)) return;

    var uren = parseFloat(blok.dataset.uren || '24');
    var einde = moment + uren * 3600 * 1000;
    var over = moment - nu;

    /* Na het venster verdwijnt alles. Geen oude "NU LIVE" die blijft hangen
       terwijl de drop een week oud is. */
    if (nu >= einde) { blok.hidden = true; return; }

    blok.hidden = false;

    var label = blok.querySelector('[data-lf-drop-label]');
    var knop = blok.querySelector('[data-lf-drop-knop]');
    var mail = blok.querySelector('[data-lf-drop-mail]');
    var klokTekst = blok.querySelector('[data-lf-drop-klok]');

    if (over <= 0) {
      /* Het is zover. De cijfers verdwijnen; de knop zegt al "Bekijk de drop",
         dus die tekst niet nog eens herhalen naast het label. */
      blok.classList.add('is-live');
      if (label) {
        label.textContent = blok.dataset.tekstLive || 'LIVE NOW';
        /* Het label kan verborgen zijn als het voor de drop dubbelde met de
           collectienaam; "NU LIVE" dubbelt nooit, dus weer tonen. */
        label.hidden = false;
      }
      if (klokTekst) klokTekst.textContent = '';
      if (knop) knop.hidden = false;
      /* Aanmelden voor een herinnering slaat nergens meer op zodra het live is. */
      if (mail) mail.hidden = true;
      return;
    }

    /* Nog niet zover. De knop naar de collectie blijft wél staan: daar zitten de
       grote aftelklok en de aanmelding voor de herinnering, dus dit is vóór het
       moment de nuttigste plek waar iemand heen kan. Zie de toelichting bij de
       knop in snippets/lodyfair-drop.liquid.

       Expliciet op false zetten en niet alleen "met rust laten": de regel
       hierboven verbergt hem nooit, maar een vorige ronde of een gecachete
       pagina kan hem wel verborgen achterlaten. */
    if (knop) knop.hidden = false;
    if (mail) mail.hidden = false;

    var totaal = Math.floor(over / 1000);
    var d = Math.floor(totaal / 86400);
    var u = Math.floor((totaal % 86400) / 3600);
    var m = Math.floor((totaal % 3600) / 60);
    var s = totaal % 60;

    var vak = {
      '[data-lf-drop-dagen]': tweeCijfers(d),
      '[data-lf-drop-uren]': tweeCijfers(u),
      '[data-lf-drop-minuten]': tweeCijfers(m),
      '[data-lf-drop-seconden]': tweeCijfers(s)
    };
    Object.keys(vak).forEach(function (sel) {
      var el = blok.querySelector(sel);
      if (el) el.textContent = vak[sel];
    });

    if (klokTekst) {
      klokTekst.textContent = (d > 0 ? d + 'd ' : '') +
        tweeCijfers(u) + ':' + tweeCijfers(m) + ':' + tweeCijfers(s);
    }
  }

  function teken() {
    var nu = Date.now();
    for (var i = 0; i < blokken.length; i++) tekenBlok(blokken[i], nu);
  }

  /* De headers plakken onder de balk in plaats van eroverheen. Daarvoor moeten
     ze weten hoe hoog die balk is, en dat verschilt per schermbreedte omdat de
     tekst op smalle schermen doorloopt naar een tweede regel. Meten dus, en
     opnieuw meten zodra het scherm draait of van maat verandert. */
  var balk = document.querySelector('[data-lf-drop-balk]');

  function meetBalk() {
    var hoogte = (balk && !balk.hidden) ? Math.round(balk.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--lf-drop-h', hoogte + 'px');
  }

  /* ---------- koopblokkade op de productpagina ----------

     TWEE GRENDELS, EN ZE MOETEN ALLEBEI DICHT KUNNEN.

     1. De klok. Vóór het droptijdstip kan er niets besteld worden, punt. Ook
        niet als de voorraad per ongeluk te vroeg aangezet wordt — de tijd wint
        hier altijd van de voorraad.
     2. De voorraad. Na het tijdstip beslist Shopify: is de variant uitverkocht,
        dan blijft de knop dicht.

     Waarom dit script er is naast de blokkade die Liquid al meegeeft: Shopify
     kan de pagina uit de cache serveren, en dan is de tijd van het moment van
     cachen. Deze lus rekent elke seconde opnieuw op de klok van de bezoeker.

     En waarom het naar de variantkiezer luistert: het thema zet de knop bij
     elke variantwissel zelf op "wel of niet beschikbaar", puur op voorraad.
     Zonder deze regel zou een klant vóór de drop een andere maat kunnen kiezen
     en daarmee de knop openzetten.

     Zodra het moment voorbij is bemoeien we ons nergens meer mee: de blokkade
     gaat eraf, de lus stopt, en het thema doet weer wat het altijd deed. */
  (function () {
    var knop = document.querySelector('[name="add"], .add-to-cart');
    if (!knop || !knop.hasAttribute('data-lf-drop-blokkade')) return;

    var bron = document.querySelector('[data-lf-drop-balk], [data-lf-drop-klokblok]');
    if (!bron) return;
    var moment = Date.parse(bron.dataset.moment);
    if (isNaN(moment)) return;

    /* DE WACHTTEKST KOMT UIT HET DROPTIJDSTIP, NIET UIT EEN VASTE ZIN.

       In het taalbestand stond "Bestelbaar vanaf dinsdag 19:00" — een restant
       van de vorige drop. Bij een volgende drop op een andere dag klopt zo'n
       zin niet meer, en dat merk je pas als een klant het leest.

       De dag en het tijdstip worden hier uit het moment gerekend, vastgezet op
       Europe/Amsterdam. Niet op de tijdzone van de bezoeker: "vrijdag 19:00" is
       de tijd van de winkel, en iemand die vanuit Bali kijkt hoort dezelfde zin
       te lezen. De browser weet zelf of het die datum zomertijd is, dus de
       omrekening klopt ook na de laatste zondag van oktober. */
    function wachtzin() {
      var d = new Date(moment);
      var opts = { timeZone: 'Europe/Amsterdam' };
      try {
        var dag = d.toLocaleDateString('nl-NL', Object.assign({ weekday: 'long' }, opts));
        var tijd = d.toLocaleTimeString('nl-NL', Object.assign({ hour: '2-digit', minute: '2-digit' }, opts));
        return 'Bestelbaar vanaf ' + dag + ' ' + tijd;
      } catch (e) {
        /* Lukt de omrekening niet, dan liever een vage maar ware zin dan een
           verkeerde dag. */
        return 'Coming soon';
      }
    }

    var tekstWacht = wachtzin();
    var tekstVrij = knop.getAttribute('data-lf-drop-vrij') || tekstWacht;
    var tekstUit = knop.getAttribute('data-lf-drop-uit') || 'Uitverkocht';
    var form = knop.closest ? knop.closest('form[action*="/cart/add"]') : null;
    var laatsteVariant = null;
    var timer = null;

    /* Of de gekozen variant voorraad heeft. Eerst wat de variantkiezer als
       laatste doorgaf; is er nog niets gewisseld, dan de variant die in het
       formulier staat opzoeken in het variantenlijstje van het thema. */
    function beschikbaar() {
      if (laatsteVariant) return !!laatsteVariant.available;
      var lijst = [];
      var bak = document.querySelector('[data-variant-json]');
      try { lijst = JSON.parse(bak.textContent); } catch (e) { return false; }
      var kiezer = form ? form.querySelector('[name="id"]') : null;
      var id = kiezer ? parseInt(kiezer.value, 10) : 0;
      for (var i = 0; i < lijst.length; i++) {
        if (lijst[i].id === id) return !!lijst[i].available;
      }
      return false;
    }

    function beoordeel() {
      if (Date.now() < moment) {
        knop.disabled = true;
        knop.textContent = tekstWacht;
        return;
      }
      /* Vanaf hier gaat het niet meer over de klok maar over de voorraad, en
         dat hoort de knop ook te zeggen. "Bestelbaar vanaf vrijdag 19:00" laten
         staan terwijl het al zaterdag is, is misleidend. */
      knop.disabled = !beschikbaar();
      knop.textContent = knop.disabled ? tekstUit : tekstVrij;
      knop.removeAttribute('data-lf-drop-blokkade');
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    document.addEventListener('variant:change', function (e) {
      laatsteVariant = e.detail && e.detail.variant;
      beoordeel();
    });

    /* Laatste slot. De knop kan uitstaan en tóch verstuurd worden — met een
       toetsenbord, of doordat een ander script het formulier indient. Vóór het
       moment gaat er niets weg. */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (Date.now() < moment) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }

    beoordeel();
    timer = window.setInterval(beoordeel, 1000);
  })();

  teken();
  meetBalk();
  setInterval(function () { teken(); meetBalk(); }, 1000);
  window.addEventListener('resize', meetBalk);

  /* ---------- aanmelden voor de herinnering ---------- */

  var form = document.querySelector('[data-lf-drop-form]');
  if (!form) return;

  var veld = form.querySelector('[data-lf-drop-email]');
  var knop = form.querySelector('[data-lf-drop-verstuur]');
  var melding = document.querySelector('[data-lf-drop-melding]');

  function meld(tekst, goed) {
    if (!melding) return;
    melding.textContent = tekst;
    melding.classList.toggle('is-goed', !!goed);
    melding.classList.toggle('is-fout', !goed);
    melding.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var adres = (veld.value || '').trim();
    if (!adres) return;

    knop.disabled = true;
    meld(form.dataset.tekstBezig || 'One moment…', true);

    /* Klaviyo's client-side aanmeldpunt. Werkt met het publieke bedrijfs-id;
       er staat dus geen geheime sleutel in het thema. Klaviyo legt zelf het
       toestemmingsmoment vast bij het profiel. */
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.bedrijf), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: adres } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.lijst } } }
        }
      })
    })
      .then(function (r) {
        if (r.ok || r.status === 202) {
          meld(form.dataset.tekstGoed || 'You\'re on the list — we\'ll email you when the drop is live.', true);
          form.reset();
          form.hidden = true;
        } else {
          knop.disabled = false;
          meld(form.dataset.tekstFout || 'That didn\'t work. Please try again.', false);
        }
      })
      .catch(function () {
        knop.disabled = false;
        meld(form.dataset.tekstFout || 'That didn\'t work. Please try again.', false);
      });
  });
})();
